// @ts-check
import { SingJWT } from "./jwtTools";
import StudyItem from "../models/studies/list";
import { Appsettings, ClientSetting } from "../Appsettings";
import path from "path-browserify";
import StudyAPI from "../api/studies";

/**
 *
 * @param {string} destination - direccion de correo electronico
 * @param {StudyItem} study - objeto del estudio
 * @param {number} expiresIn - tiempo en horas para que expire el token
 * @returns {Promise<boolean>} - promesa que retorna un objeto con los datos para compartir
 */
async function ShareMail(destination, study, expiresIn) {
  if (destination === "") {
    console.error("Destination is required");
    return false;
  }
  let token = SingJWT({ ID: study.id }, { expiresIn: `${expiresIn}h` });
  let url = path.join(window.location.origin, "externo", token);
  let data = {
    destino: destination,
    data: url,
    nombre: study.getPatientName(),
    modalidad: study.getModality(),
    institucion: ClientSetting.InstitutionName,
  };
  try {
    await StudyAPI.ShareMail(data);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export default ShareMail;
